/* ============================================================================
   MoveOn everyday offer + shared cart drawer  (assets/mo-offer.js)
   ----------------------------------------------------------------------------
   ONE copy of the buy box state, the cart drawer, the LiveOn add-on and the
   checkout hand-off, shared by sections/mo-pdp, mo-listicle and mo-listicle-v2.
   Markup: snippets/mo-offer-buybox.liquid + snippets/mo-offer-cart.liquid.
   Styles: assets/mo-offer.css.

   Offer (2026-09-28, permanent): a box is 16 sachets, so 2 boxes overshoot a
   30-day plan by 2 and 6 boxes overshoot 90 by 6 - the overshoot is sold as
   FREE sachets. "Regular price" is $146 per 30 days ($146 / $438), i.e. the
   2-box one-time price, so 30-day one-time is exactly "no discount" (Brandon
   2026-10-03: "it was 146, not 147"). A saving under $5 is shown as no discount.

   Pages talk to this file only through:
     - clicks on [data-add-to-cart] / [data-cart-open] anywhere on the page
     - the `mo-offer:change` event (detail = the current selection), which the
       page's own sticky bar listens to
     - window.MoOffer (state + add/open/close) for anything else
   ============================================================================ */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var money = function (n) { return '$' + (Number.isInteger(n) ? String(n) : n.toFixed(2)); };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------------------------------------ MoveOn -- */
  /* Live variant + Appstle selling-plan ids on immority.store (verified 2026-10-03).
     Keys are the [data-bundle] values in the snippet: 3 = 90-day, 1 = 30-day,
     0 = the 1-box one-time trial link.
     30-day uses plan 5760123121 "30-day subscription (FREE extra +2 sachets)", created
     2026-10-03 for this offer. The OLD 2-box plan 5251465457 ("2 box - $65/box", same
     variant, same $130 / 30 days) stays attached to x2 because the live V6.5 pages still
     send it - do not detach it until this theme is published. */
  var REG_PER_30_DAYS = 146, MIN_SAVE = 5;
  var TIERS = {
    3: { label: '90-Day Supply', title: '6 Boxes', boxes: 6, sachets: 96, days: 90, price: 398, sub: 347, variant: 48680313585905, plan: 5695078641, every: '90 days' },
    1: { label: '30-Day Supply', title: '2 Boxes', boxes: 2, sachets: 32, days: 30, price: 146, sub: 130, variant: 46917573804273, plan: 5760123121, every: '30 days' },
    0: { label: '16-day trial',  title: '1 Box',   boxes: 1, sachets: 16, days: 16, price: 87,  sub: 79,  variant: 46917573771505, plan: 5251432689, every: '16 days' }
  };
  function tier(i, sub) {
    var d = TIERS[i], reg = Math.round(REG_PER_30_DAYS * d.days / 30);
    var now = sub ? d.sub : d.price, save = reg - now, discounted = save >= MIN_SAVE;
    return { d: d, now: now, reg: reg, save: save, discounted: discounted,
             pct: Math.round(save / reg * 100), free: d.sachets - d.days,
             mo: Math.ceil(now * 30 / d.days - 1e-9) };
  }

  /* ------------------------------------------------------------ LiveOn -- */
  /* One-time add-on, two sizes, each its own VARIANT (never "3 x 1 box").
     Launch prices come from the store's discount codes (LAUNCH1BOX = $22 off x1,
     LAUNCH3BOX = $40 off x3, both active with no end date); the drawer shows the
     launch price and checkout applies the code through the return_to URL. */
  var LO = {
    handle: 'liveon%E2%84%A2',
    sizes: {
      1: { variant: 48218961248497, list: 87,  price: 65,  save: 22, code: 'LAUNCH1BOX', sachets: 16, sub: '16 sachets' },
      3: { variant: 48218961314033, list: 199, price: 159, save: 40, code: 'LAUNCH3BOX', sachets: 48, sub: '$53 a box' }
    }
  };
  function loTier(n) { n = n || st.addonBoxes; return LO.sizes[n] || LO.sizes[3]; }

  /* ------------------------------------------------------------- state -- */
  var st = {
    bundle: 3, plan: 'sub',
    cart: null,                 /* { bundle, plan, qty } once something is added */
    addon: false, addonBoxes: 3, addonQty: 1,
    open: false,
    loAvail: { 1: true, 3: true }, loChecked: false
  };
  var busy = false;

  /* ---------------------------------------------------------- Appstle -- */
  /* Appstle injects name="selling_plan" radios on the product page and its
     radios win over anything scripted, so keep them in step with the tabs.
     Harmless where there are none (the listicles). */
  function syncAppstle() {
    var want = st.plan === 'sub' ? String(TIERS[st.bundle].plan) : '';
    var picked = null;
    $$('input[name="selling_plan"]').forEach(function (r) {
      if (r.value === want && !picked) picked = r;
      r.checked = false;
    });
    if (picked) { picked.checked = true; picked.dispatchEvent(new Event('change', { bubbles: true })); }
  }

  /* ----------------------------------------------------------- buy box -- */
  function detail() {
    var sub = st.plan === 'sub', t = tier(st.bundle, sub);
    return { bundle: st.bundle, plan: st.plan, sub: sub, title: t.d.title, label: t.d.label,
             boxes: t.d.boxes, every: t.d.every, price: t.now, reg: t.reg, discounted: t.discounted };
  }
  function emit() {
    try { document.dispatchEvent(new CustomEvent('mo-offer:change', { detail: detail() })); }
    catch (e) { /* very old browsers: sticky bars just keep their last text */ }
  }

  function syncBuyBox() {
    var sub = st.plan === 'sub';
    var cur = tier(st.bundle, sub);

    $$('[data-bundle]').forEach(function (row) {
      var i = +row.getAttribute('data-bundle'), t = tier(i, sub), on = i === st.bundle;
      row.classList.toggle('is-on', on);
      var inp = $('input', row); if (inp) inp.checked = on;
      var sv = $('[data-save]', row); if (sv) { sv.textContent = 'Save ' + t.pct + '%'; sv.style.display = t.discounted ? '' : 'none'; }
      /* cards show a monthly price, rounded UP so it never undersells the real charge
         ($347 / 90 days -> $116/mo, $398 -> $133/mo); the real charge sits under it and on
         the CTA, sticky bars and drawer (Brandon 2026-10-15) */
      var pr = $('[data-price]', row); if (pr) pr.innerHTML = money(t.mo) + '<small>/mo</small>';
      var sk = $('[data-strike]', row); if (sk) { sk.textContent = money(REG_PER_30_DAYS) + '/mo'; sk.classList.toggle('is-hidden', !t.discounted); }
      var bl = $('[data-billed]', row); if (bl) bl.textContent = money(t.now) + (sub ? ' every ' + t.d.every : ' one-time');
      var sa = $('[data-sachets]', row);
      if (sa) sa.innerHTML = t.d.days + ' sachets' + (t.free > 0
        ? ' <span class="mo-pill-free">+' + t.free + ' FREE</span><span class="mo-metasep"> &middot; </span><span class="mo-daystotal">' + t.d.sachets + ' days total</span>' : '');
      var pk = $('[data-perk-save]', row);
      if (pk) { pk.textContent = 'Save ' + money(t.save) + ' compared with regular price'; pk.parentElement.style.display = t.discounted ? '' : 'none'; }
      var pf = $('[data-perk-free]', row);
      if (pf) { pf.innerHTML = '<b>' + t.free + ' extra sachets FREE</b> &middot; worth ' + money(Math.round(t.free * REG_PER_30_DAYS / 30)); pf.parentElement.style.display = t.free > 0 ? '' : 'none'; }
      var pp = $('[data-perk-plan]', row);
      if (pp) pp.textContent = sub ? 'Pause, skip or cancel anytime' : 'No subscription or recurring charges';
      /* the money-back guarantee covers subscriptions only, so it is not shown on one-time (Brandon 2026-10-06) */
      var pg = $('[data-perk-guarantee]', row); if (pg) pg.parentElement.style.display = sub ? '' : 'none';
    });

    $$('[data-plan]').forEach(function (tab) {
      var on = tab.getAttribute('data-plan') === (sub ? 'sub' : 'once');
      tab.classList.toggle('is-on', on);
      tab.setAttribute('aria-selected', String(on));
    });

    /* nudge under the tabs: the biggest one-time -> subscribe gap across the cards on show */
    var gap = 0;
    $$('[data-bundle]').forEach(function (row) { var d = TIERS[+row.getAttribute('data-bundle')]; if (d) gap = Math.max(gap, d.price - d.sub); });
    $$('[data-plan-nudge]').forEach(function (el) {
      el.innerHTML = sub ? 'Delivered on schedule. <b>Pause, skip or cancel anytime.</b>'
                         : 'Switch to a subscription to <b>save up to ' + money(gap) + ' more</b>';
    });

    $$('[data-trial-price]').forEach(function (el) { el.textContent = money(TIERS[0].price); });
    $$('[data-cta-price]').forEach(function (el) { el.textContent = money(cur.now); });
    syncAppstle();
    emit();
  }

  /* ------------------------------------------------------------ drawer -- */
  function addonOn() { return !!(st.cart && st.addon); }
  function setText(sel, txt) { $$(sel).forEach(function (el) { el.textContent = txt; }); }

  function syncAddon() {
    var card = $('[data-lo-card]'); if (!card) return;
    var on = addonOn(), t = loTier();
    var anyAvail = false;

    Object.keys(LO.sizes).forEach(function (k) {
      var n = +k, s = LO.sizes[n], avail = st.loAvail[n] !== false;
      anyAvail = anyAvail || avail;
      var opt = $('[data-lo-box="' + n + '"]', card);
      if (opt) {
        opt.hidden = !avail;
        opt.classList.toggle('is-on', n === st.addonBoxes);
        opt.setAttribute('aria-checked', String(n === st.addonBoxes));
      }
      var sub = $('[data-lo-opt-sub="' + n + '"]', card); if (sub) sub.textContent = s.sub;
      var pr = $('[data-lo-opt-price="' + n + '"]', card); if (pr) pr.textContent = money(s.price);
      var was = $('[data-lo-opt-was="' + n + '"]', card); if (was) was.textContent = money(s.list);
      var badge = $('[data-lo-opt-badge="' + n + '"]', card); if (badge) badge.textContent = 'Save ' + money(s.save);
    });

    card.hidden = !anyAvail;              /* LiveOn fully out of stock: no upsell at all */
    card.classList.toggle('is-on', on);
    var head = $('[data-lo-toggle]', card); if (head) head.setAttribute('aria-checked', String(on));
    setText('[data-lo-eyebrow]', on ? 'LiveOn added to order' : 'Add LiveOn to this order');
    var offer = $('[data-lo-offer]', card);
    if (offer) offer.innerHTML = '<b>Launch offer:</b> ' + money(t.save) + ' off, applied at checkout.';

    var line = $('[data-lo-line]');
    if (line) {
      line.classList.toggle('is-on', on);
      setText('[data-lo-line-title]', st.addonBoxes + (st.addonBoxes === 1 ? ' Box' : ' Boxes'));
      setText('[data-lo-line-sub]', t.sachets + ' sachets · 20 ml each · launch price');
      setText('[data-lo-line-price]', money(t.price));
      setText('[data-lo-line-was]', money(t.list));
      setText('[data-lo-qty]', String(st.addonQty));
      var dec = $('[data-lo-qty-dec]', line); if (dec) dec.style.opacity = st.addonQty === 1 ? '.35' : '';
    }
  }

  function syncCart() {
    var c = st.cart;
    var filled = $('[data-oc-filled]'), foot = $('[data-oc-foot]'), empty = $('[data-oc-empty]');
    if (filled) filled.style.display = c ? 'flex' : 'none';
    if (foot) foot.style.display = c ? 'flex' : 'none';
    if (empty) empty.style.display = c ? 'none' : 'block';
    if (!c) return;

    var sub = c.plan === 'sub', t = tier(c.bundle, sub), d = t.d;
    setText('[data-oc-title]', d.title);
    setText('[data-oc-sub]', d.sachets + ' sachets · 25 ml each');
    setText('[data-oc-plan]', sub ? 'Subscribe & Save · every ' + d.every : 'One-time purchase');
    setText('[data-oc-price]', money(t.now));
    var was = $('[data-oc-was]'); if (was) { was.textContent = money(t.reg); was.style.display = t.discounted ? '' : 'none'; }
    setText('[data-oc-qty]', String(c.qty));
    var dec = $('[data-qty-dec]'); if (dec) dec.style.opacity = c.qty === 1 ? '.35' : '';

    var lo = addonOn() ? loTier() : null;
    var loNow = lo ? lo.price * st.addonQty : 0, loList = lo ? lo.list * st.addonQty : 0;
    var wasTotal = (t.discounted ? t.reg : t.now) * c.qty + loList;
    var nowTotal = t.now * c.qty + loNow;
    var wt = $('[data-oc-was-total]'); if (wt) { wt.textContent = money(wasTotal); wt.style.display = wasTotal > nowTotal ? '' : 'none'; }
    setText('[data-oc-subtotal]', money(nowTotal));
    setText('[data-oc-total]', money(nowTotal));
    syncAddon();
  }

  function note(msg) {
    var n = $('[data-oc-note]'); if (!n) return;
    n.textContent = msg || ''; n.hidden = !msg;
  }

  function setCart(on) {
    if (on === st.open) return;
    st.open = on;
    var layer = $('[data-cart-layer]'); if (layer) layer.classList.toggle('is-open', on);
    document.documentElement.classList.toggle('mo-oc-lock', on);
    if (on) { var body = $('.mo-oc-body'); if (body) body.scrollTop = 0; }
  }

  function addToCart(bundle, plan) {
    var b = bundle === undefined ? st.bundle : bundle, p = plan || st.plan;
    if (st.cart && st.cart.bundle === b && st.cart.plan === p) st.cart.qty += 1;
    else st.cart = { bundle: b, plan: p, qty: 1 };
    note('');
    syncCart();
    setCart(true);
  }
  function setAddon(on) { st.addon = !!on; if (on) note(''); else st.addonQty = 1; syncCart(); }

  /* -------------------------------------------------- LiveOn stock guard -- */
  /* LiveOn variants are inventory-policy DENY. The checkout form posts MoveOn and
     LiveOn in ONE /cart/add, and Shopify rejects the whole request if any line is
     unavailable - so a ticked box + empty LiveOn stock would mean NO order at all.
     Read availability at load (hides a sold-out size, or the whole card) and again
     right before checkout. Any network trouble resolves to "unchanged". */
  function checkLiveOn(timeoutMs) {
    return new Promise(function (resolve) {
      var done = false, finish = function () { if (!done) { done = true; resolve(st.loAvail); } };
      setTimeout(finish, timeoutMs || 4000);
      fetch(root + 'products/' + LO.handle + '.js', { cache: 'no-store', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (p && p.variants) {
            p.variants.forEach(function (v) {
              Object.keys(LO.sizes).forEach(function (k) { if (LO.sizes[k].variant === v.id) st.loAvail[k] = !!v.available; });
            });
            st.loChecked = true;
          }
          finish();
        })
        .catch(finish);
    });
  }

  /* ---------------------------------------------------------- checkout -- */
  /* Native form POST to /cart/add: Appstle patches window.fetch AND XHR and
     re-renders its selling_plan radios after any cart change, so a scripted add
     can lose the race and a Subscribe order silently lands one-time (seen live).
     The form bypasses both patches, keeps the same cart (the affiliate_id
     attribute survives cart/clear.js) and return_to lands on checkout - via the
     discount URL when LiveOn is on, so its launch code is applied. */
  function release() {
    busy = false;
    $$('[data-checkout]').forEach(function (el) { el.style.pointerEvents = ''; el.style.opacity = ''; });
  }
  window.addEventListener('pageshow', release);
  window.addEventListener('popstate', release);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) release(); });

  function goToCheckout(trigger) {
    if (busy || !st.cart) return;
    busy = true;
    if (trigger) { trigger.style.pointerEvents = 'none'; trigger.style.opacity = '.7'; }

    var proceed = function () {
      syncAppstle();
      var c = st.cart, m = TIERS[c.bundle], lo = addonOn() ? loTier() : null;
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .catch(function () {})
        .then(function () {
          var f = document.createElement('form');
          f.method = 'POST'; f.action = root + 'cart/add'; f.style.display = 'none';
          var add = function (k, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = k; i.value = v; f.appendChild(i); };
          if (lo) {
            add('items[0][id]', String(m.variant));
            add('items[0][quantity]', String(c.qty));
            if (c.plan === 'sub') add('items[0][selling_plan]', String(m.plan));
            add('items[1][id]', String(lo.variant));
            add('items[1][quantity]', String(st.addonQty || 1));
            add('return_to', '/discount/' + lo.code + '?redirect=%2Fcheckout');
          } else {
            add('id', String(m.variant));
            add('quantity', String(c.qty));
            if (c.plan === 'sub') add('selling_plan', String(m.plan));
            add('return_to', '/checkout');
          }
          document.body.appendChild(f);
          f.submit();
        });
    };

    if (!addonOn()) { proceed(); return; }
    checkLiveOn(4000).then(function (avail) {
      if (avail[st.addonBoxes] === false) {
        st.addon = false; st.addonQty = 1;
        settleLiveOnDefault();   /* selection moves to the in-stock size; the box stays unticked */
        syncCart();
        var anyLeft = Object.keys(LO.sizes).some(function (k) { return st.loAvail[k] !== false; });
        note(anyLeft
          ? 'That LiveOn size just sold out, so we took it off this order. Pick another size to add it back, or tap checkout to continue with MoveOn only.'
          : 'LiveOn just sold out, so we took it off this order. Tap checkout to continue with MoveOn.');
        release();
        return;
      }
      proceed();
    });
  }

  /* ------------------------------------------------------------ wiring -- */
  function onClick(e) {
    var t;
    if ((t = e.target.closest('[data-plan]')))      { st.plan = t.getAttribute('data-plan'); syncBuyBox(); return; }
    if ((t = e.target.closest('[data-bundle]')))    { st.bundle = +t.getAttribute('data-bundle'); syncBuyBox(); return; }
    if ((t = e.target.closest('[data-buy-trial]'))) { addToCart(0, 'once'); return; }
    if ((t = e.target.closest('[data-add-to-cart]'))) { e.preventDefault(); addToCart(); return; }
    if ((t = e.target.closest('[data-cart-open]')))  { e.preventDefault(); setCart(true); return; }
    if ((t = e.target.closest('[data-cart-close]'))) { setCart(false); return; }
    if ((t = e.target.closest('[data-checkout]')))   { e.preventDefault(); goToCheckout(t); return; }
    if ((t = e.target.closest('[data-qty-inc]')))    { if (st.cart) { st.cart.qty = Math.min(10, st.cart.qty + 1); syncCart(); } return; }
    if ((t = e.target.closest('[data-qty-dec]')))    { if (st.cart && st.cart.qty > 1) { st.cart.qty -= 1; syncCart(); } return; }
    if ((t = e.target.closest('[data-lo-qty-inc]'))) { st.addonQty = Math.min(10, (st.addonQty || 1) + 1); syncCart(); return; }
    if ((t = e.target.closest('[data-lo-qty-dec]'))) { if (st.addonQty > 1) { st.addonQty -= 1; syncCart(); } return; }
    if ((t = e.target.closest('[data-lo-box]')))     { st.addonBoxes = +t.getAttribute('data-lo-box'); if (st.addon) syncCart(); else syncAddon(); return; }
    if ((t = e.target.closest('[data-lo-toggle]')))  { setAddon(!st.addon); return; }
    if ((t = e.target.closest('[data-lo-remove]')))  { setAddon(false); return; }
  }

  /* At load nothing is chosen yet, so a sold-out default size just moves the
     selection to the size that is in stock (or drops the add-on if neither is).
     At checkout time the shopper HAS chosen: never swap sizes silently there. */
  function settleLiveOnDefault() {
    if (st.loAvail[st.addonBoxes] !== false) return;
    var other = Object.keys(LO.sizes).filter(function (k) { return st.loAvail[k] !== false; })[0];
    if (other) st.addonBoxes = +other; else st.addon = false;
  }

  function init() {
    document.addEventListener('click', onClick);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && st.open) setCart(false);
      if ((e.key === 'Enter' || e.key === ' ') && e.target && e.target.hasAttribute && e.target.hasAttribute('data-lo-toggle')) { e.preventDefault(); setAddon(!st.addon); }
    });
    syncBuyBox();
    syncCart();
    checkLiveOn(6000).then(function () { settleLiveOnDefault(); syncCart(); });
    /* the page scripts register their sticky-bar listeners after this file ran
       (both are deferred, this one first), so fire once more when they are in */
    window.addEventListener('DOMContentLoaded', emit);
    window.addEventListener('load', emit);
  }

  window.MoOffer = {
    state: st, tiers: TIERS, liveOn: LO, tier: tier, detail: detail,
    select: function (bundle, plan) { if (bundle !== undefined) st.bundle = bundle; if (plan) st.plan = plan; syncBuyBox(); },
    add: addToCart, open: function () { setCart(true); }, close: function () { setCart(false); }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
